import {
	AutoComplete,
	Badge,
	Button,
	Dropdown,
	Input,
	Layout,
	Menu,
	// theme,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import "./styled/styles.scss";
import { complexDigitToman, deleteAllCookies, faDigits } from "../../tools/tools";
import { useLocation, useNavigate } from "react-router-dom";
import { _adr } from "../../address";
import { createContext, createElement, useContext, useEffect, useState } from "react";
import { useAPIPublic, useReport } from "../../tools/api";
import { globalValue } from "../../reducer/serviceReducerGlobala";
import { clearApp, clearTokenOTP } from "../../tools/services";
import { GlobalMenu } from "./menu";
import { Ticker, isAptelBirthday } from "./ticker";
import { ImpersonationBar } from "./impersonationBar";
import { activeToken, clearUserStale, filterImpersonationMenu, isBlockedPath, isImpersonating, isUserStale } from "../../tools/impersonation";
import { Roles } from "../../tools/services";
import { MenuUnfoldOutlined, MenuFoldOutlined } from "@ant-design/icons";

const { Header, Sider } = Layout;

const MainLayoutContext = createContext();
export const useLayout = () => {
	return useContext(MainLayoutContext);
};
const MenuBadge = ({ label, count }) => (
	<span className="menu-badge-label">
		{label}
		{count > 0 && <span className="menu-badge">{faDigits(count)}</span>}
	</span>
);

// full side menu (role-filtered); nav is injectable so the same tree can be built with a recording nav
const buildMenu = (nav, user) => {
	const roles = user?.roles ?? [];
	return [
		...GlobalMenu(nav, user),
		(roles.includes(Roles.Dealer_LoginAs) || roles.includes(Roles.Dealer_LoginAs_Audit)) && {
			key: "menuLoginAsRoot",
			label: "ورود به عنوان",
			icon: <i className="icon-user"></i>,
			children: [
				roles.includes(Roles.Dealer_LoginAs) && {
					key: "menuLoginAs",
					label: "ورود به پنل نماینده",
					onClick: () => nav(_adr.Root + _adr.LoginAs.Index),
				},
				roles.includes(Roles.Dealer_LoginAs_Audit) && {
					key: "menuLoginAsLogs",
					label: "گزارش ورود به عنوان",
					onClick: () => nav(_adr.Root + _adr.LoginAs.Index + _adr.LoginAs.Logs),
				},
			],
		},
	];
};

// ponytail: menu items only carry onClick handlers, so routes are discovered by running each handler with a nav that
// records the path (window.open is stubbed for the external-link items); give items an explicit path if this grows
const collectMenuPaths = (user) => {
	const found = {};
	let current = null;
	const record = (path) => (found[current.key] = { path: String(path).toLowerCase(), parent: current.parent });
	const realOpen = window.open;
	window.open = () => null;
	try {
		const walk = (items, parent) =>
			items.forEach((item) => {
				if (!item) return;
				if (item.children) return walk(item.children, item.key);
				current = { key: item.key, parent };
				try {
					item.onClick?.();
				} catch {}
			});
		walk(buildMenu(record, user), null);
	} finally {
		window.open = realOpen;
	}
	return found;
};

// exact route match first, otherwise the entry sharing the longest leading path segments (e.g. later wizard steps)
const activeMenu = (paths, pathname) => {
	const here = pathname.toLowerCase().split("/").filter(Boolean);
	let best = null;
	let bestScore = 1; // must share more than the app root segment
	Object.entries(paths).forEach(([key, { path, parent }]) => {
		const segs = path.split("/").filter(Boolean);
		let n = 0;
		while (n < segs.length && n < here.length && segs[n] === here[n]) n++;
		const score = n === segs.length && n === here.length ? 1000 : n;
		if (score > bestScore) {
			best = { key, parent };
			bestScore = score;
		}
	});
	return best;
};

// PendingDocumentUploadCounts used to run on every navigation. Now: at most once a minute per identity, one request at a time,
// but always fresh on the dashboard and the pending-upload lists, where a re-uploaded request has to drop out right away.
const PENDING_TTL_MS = 60 * 1000;
const pendingCache = { token: null, at: 0, data: null, inflight: null };
const pendingCountsFor = (pathname, fetchCounts) => {
	const token = activeToken();
	const fresh = pendingCache.token === token && Date.now() - pendingCache.at < PENDING_TTL_MS;
	const mustRefresh = pathname.endsWith(_adr.Home) || pathname.includes("/pending");
	if (fresh && !mustRefresh) return Promise.resolve(pendingCache.data);
	if (pendingCache.inflight && pendingCache.token === token) return pendingCache.inflight;
	pendingCache.token = token;
	pendingCache.inflight = fetchCounts()
		.then((counts) => {
			if (counts && pendingCache.token === token) Object.assign(pendingCache, { at: Date.now(), data: counts });
			return counts;
		})
		.finally(() => {
			if (pendingCache.token === token) pendingCache.inflight = null;
		});
	return pendingCache.inflight;
};

export const MainLayout = ({ children }) => {
	const [header, setHeader] = useState(null);
	const [footer, setFooter] = useState(null);

	const setLayout = (headerContext, footerContext) => {
		setHeader(headerContext);
		setFooter(footerContext);
	};

	const { queryCurrentUser, queryUserRoles } = useAPIPublic();
	const { pendingDocumentUploadCounts } = useReport();
	const dispatch = useDispatch();
	const { _currentUser } = useSelector((state) => {
		return state?.another;
	});
	const nav = useNavigate();
	const location = useLocation();
	// const {
	//   token: { colorBgContainer },
	// } = theme.useToken();
	var timeUser;
	useEffect(() => {
		// const currentUser = () => {
		//   timeUser = setInterval(async () => {
		//     let _currentUser = await queryCurrentUser();
		//     if (_currentUser) {
		//       dispatch(globalValue({ _currentUser: _currentUser }));
		//     }
		//   }, 30000);
		// };
		// currentUser();
		// return () => clearInterval(timeUser);
	}, []);
	const handleRefresh = async () => {
		let _currentUser = await queryCurrentUser();
		if (_currentUser) {
			let resRoles = await queryUserRoles();
			if (resRoles) {
				dispatch(globalValue({ _currentUser: { ..._currentUser, roles: [...resRoles] } }));
			}
		}
	};
	useEffect(() => {
		// after "ورود به عنوان" start/exit the persisted user may belong to the other identity: reload it with the active token
		if (isUserStale()) handleRefresh().then(clearUserStale);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const [items, setItems] = useState([]);
	const [sideMenu, setSideMenu] = useState();
	// pending document-upload counts for the menu badge and the dashboard card (see pendingCountsFor)
	const [pendingDocs, setPendingDocs] = useState(pendingCache.data);
	useEffect(() => {
		let cancelled = false;
		pendingCountsFor(location.pathname, pendingDocumentUploadCounts).then((counts) => !cancelled && counts && setPendingDocs(counts));
		return () => {
			cancelled = true;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location.pathname]);
	useEffect(() => {
		const menu = buildMenu(nav, _currentUser);
		setMenuPaths(collectMenuPaths(_currentUser));
		// numeric badge next to "آپلود مدارک ناقص" and its sub-items; hidden when the count is 0
		const total = pendingDocs?.TotalCount ?? 0;
		const sub = { menu01sub04: pendingDocs?.SPPurchaseCount, menu02sub03: pendingDocs?.COPurchaseCount, menu03sub04: pendingDocs?.SWPurchaseCount };
		const withBadges = menu.map((item) =>
			item?.key === "menuUploadDocs"
				? {
						...item,
						label: <MenuBadge label={item.label} count={total} />,
						children: item.children.map((c) => (c && sub[c.key] ? { ...c, label: <MenuBadge label={c.label} count={sub[c.key]} /> } : c)),
				  }
				: item,
		);
		setSideMenu(isImpersonating() ? filterImpersonationMenu(withBadges) : withBadges);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [_currentUser, pendingDocs]);

	// highlight the menu entry of the current page and open its group
	const [menuPaths, setMenuPaths] = useState({});
	const [openKeys, setOpenKeys] = useState([]);
	const active = activeMenu(menuPaths, location.pathname);
	useEffect(() => {
		if (active?.parent) setOpenKeys((keys) => (keys.includes(active.parent) ? keys : [...keys, active.parent]));
	}, [active?.parent]);
	useEffect(() => {
		const initialComponents = async () => {
			setItems([
				// {
				//   icon: (
				//     <>
				//       <i className="icon-bank"></i>
				//     </>
				//   ),
				//   label: "ثبت شماره حساب",
				//   key: "0",
				//   className: "item-profile-menu",
				//   onClick: () => {
				//     nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.AccountList);
				//   },
				// },
				{
					icon: (
						<>
							<i className="icon-password"></i>
						</>
					),
					label: "تغییررمزعبور",
					key: "1",
					className: "item-profile-menu",
					onClick: () => {
						nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.ChangePassword);
					},
				},
				{
					icon: (
						<>
							<i className="icon-edit-profile"></i>
						</>
					),
					label: "ویرایش پروفایل",
					key: "2",
					onClick: () => {
						nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.ViewProfile);
					},
					className: "item-profile-menu",
				},
				{
					icon: (
						<>
							<i className="icon-exit"></i>
						</>
					),
					label: "خروج",
					key: "3",
					onClick: () => {
						clearApp();
						nav(_adr.Root + _adr.Login.Index);
					},
					className: "item-profile-menu",
				},
			]);
		};
		initialComponents();
	}, []);

	const [collapsed, setCollapsed] = useState(true);
	const [activeResponsive, setactiveResponsive] = useState(false);
	const [widthResponsive, setwidthResponsive] = useState("80px");

	const toggleCollapsed = () => {
		setCollapsed(!collapsed);
	};

	// تغییر استایل برای قرار دادن منو بر روی محتوا
	const siderStyle = {
		position: "absolute",
		right: 0,
		zIndex: 1,
	};

	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth <= 1024) {
				setCollapsed(true);
			} else {
				setCollapsed(false);
			}
		};
		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	// starting something from the menu or landing on the dashboard ends the previous customer's OTP session
	const handleMenuClick = () => {
		clearTokenOTP();
		handleCloseCollapse();
	};
	useEffect(() => {
		if (location.pathname.toLowerCase() === (_adr.Root + _adr.Home).toLowerCase()) clearTokenOTP();
	}, [location.pathname]);

	const handleCloseCollapse = () => {
		if (window.innerWidth <= 1024) {
			setCollapsed(true);
		}
	};

	return (
		<>
			<MainLayoutContext.Provider value={{ header, footer, setLayout, pendingDocs }} style={{ minHeight: "100vh" }}>
				<Layout style={{ minHeight: "100vh" }}>
					<Header className="app-header" style={{ background: "#fff" }}>
						<div className="holder-header-layout">
							<div className="holder-brand">
								<div className="holder-row-brand">
									{activeResponsive && (
										<div className="holder-burger-menu">
											{createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
												className: "trigger",
												onClick: toggleCollapsed,
											})}
										</div>
									)}

									<div className={isAptelBirthday() ? "holder-icon bday-hat" : "holder-icon"}>
										<img src={process.env.PUBLIC_URL + process.env.REACT_APP_PATH + "/assets/images/logo-small.png"} alt="" />
									</div>
									<div className="holder-text-icon">
										<img src={process.env.PUBLIC_URL + process.env.REACT_APP_PATH + "/assets/images/text-logo-small.png"} alt="" />
									</div>
								</div>
							</div>
							<div className="holder-action-header" onClick={handleCloseCollapse}>
								<div className="holder-searcharea">
									{/* <AutoComplete
                    style={{
                      width: "30rem",
                    }}
                  >
                    <Input
                      placeholder="جستجوی شماره، سریال نامبر، نام و نام خانوادگی، شماره تراکنش"
                      size="large"
                      prefix={<i className="icon-search"></i>}
                    />
                  </AutoComplete> */}
								</div>
								<div className="holder-show-info">
									<div className="row-item-info">
										<div className="holder-profile">
											<div className="profile-item">
												<Dropdown
													className="expand-profile-menu"
													overlayClassName="expand-overlay-profile-menu"
													menu={{ items }}
													trigger={["click"]}
													placement="bottomLeft">
													<div className="holder-icon">
														<i className="icon-user"></i>
													</div>
												</Dropdown>
											</div>
										</div>
										<div className="holder-notifi">
											<div className="notifi-item">
												{/* <Dropdown trigger={["click"]} placement="bottom"> */}
												<Badge size="small" onClick={() => nav(_adr.Root + _adr.Notification.Index)}>
													<i className="icon-ring"></i>
												</Badge>
												{/* </Dropdown> */}
											</div>
										</div>
										<div className="holder-wallet">
											<div className="wallet-item">
												<Button onClick={handleRefresh} type="button" className="btn-normal btn-red" icon={<i className="icon-wallet"></i>}>
													اعتبارشما: <span dir="ltr">{complexDigitToman(_currentUser?.walletAmount)}</span> تومان
												</Button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Header>
					<ImpersonationBar />
					<Ticker />
					<Layout>
						{/* <Sider style={`slide-layout` + collapsed ? null : siderStyle} collapsible collapsed={collapsed}>
              <Menu mode="inline" defaultSelectedKeys={["1"]} defaultOpenKeys={["sub1"]} className="menu-sidebar" items={sideMenu} />
            </Sider> */}
						<Sider
							trigger={null}
							collapsible
							collapsed={collapsed}
							className={`slide-layout`}
							breakpoint="lg"
							onBreakpoint={(e) => {
								if (e) {
									setCollapsed(true);
									setactiveResponsive(true);
									setwidthResponsive("0");
								} else {
									setactiveResponsive(false);
									setwidthResponsive("80px");
									setCollapsed(false);
								}
							}}
							// collapsedWidth="0"
							onCollapse={(value) => setCollapsed(value)}
							collapsedWidth={widthResponsive}
							width={250}>
							<Menu
								mode="inline"
								onClick={handleMenuClick}
								selectedKeys={active ? [active.key] : []}
								openKeys={openKeys}
								onOpenChange={setOpenKeys}
								className="menu-sidebar"
								items={sideMenu}
							/>
						</Sider>
						<Layout
							style={{
								padding: "0 0px 24px",
								transition: " all 0.5s",
							}}
							onClick={handleCloseCollapse}
							className={`${!collapsed ? "overlay-layout" : ""}`}>
							{isImpersonating() && isBlockedPath(location.pathname) ? (
								<div className="impersonation-blocked">
									<h2>این بخش در حالت «ورود به عنوان» در دسترس نیست</h2>
									<p>عملیات مالی و فروش فقط با ورود مستقیم خود نماینده انجام می‌شود.</p>
									<Button onClick={() => nav(_adr.Root + _adr.Home)}>بازگشت به داشبورد</Button>
								</div>
							) : (
								children
							)}
						</Layout>
					</Layout>
				</Layout>
				{header}
			</MainLayoutContext.Provider>
		</>
	);
};

export default MainLayout;
